var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-wrapper site-page--not-found" }, [
    _c("div", { staticClass: "site-content__wrapper" }, [
      _c(
        "div",
        { staticClass: "site-content" },
        [
          _c("h2", { staticClass: "not-found-title" }, [_vm._v("404")]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.$router.go(-1)
                }
              }
            },
            [_vm._v("返回上一页")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "not-found-btn-gohome",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$router.push("/")
                }
              }
            },
            [_vm._v("进入首页")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "not-found-desc" }, [
      _vm._v("抱歉！您访问的页面"),
      _c("em", [_vm._v("失联")]),
      _vm._v("啦 ...")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3965bb67", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3965bb67","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Error/404.vue
// module id = null
// module chunks = 